export function getQlikSheetId(state) {
  const { page } = state.navigationSelection;

  if (page.hasOwnProperty('sheet')) {
    return page.sheet[0].qlikEngineObjectId;
  }

  return '';
}
